exports.STYLE_EVALUATION = {
  exceptional: {
    label: 'exceptional',
    score: 10,
    style: [8, 10],
  },
  great: {
    label: 'great',
    score: 5,
    style: [4, 7],
  },
  solid: {
    label: 'solid',
    score: 1,
    style: [1, 3],
  },
};
